import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const projects = [{
  id: 1,
  title: "Maurerarbeiten",
  category: "Wohnbau",
  image: "https://lecibau.de/wp-content/uploads/2026/02/WhatsApp-Image-2026-02-25-at-13.13.48.jpeg?v=sx7irv35nu",
  description: "\n"
}, {
  id: 2,
  title: "Betonarbeiten",
  category: "Gewerbebau",
  image: "https://lecibau.de/wp-content/uploads/2026/02/cc043bf2-87e7-457d-9d32-8c62e323f5dd-2.jpg?v=e04ec5cfiq",
  description: "\n"
}, {
  id: 3,
  title: "Stahlarbeiten",
  category: "Exklusiv",
  image: "https://lecibau.de/wp-content/uploads/2026/02/WhatsApp-Image-2026-02-25-at-13.13.49.jpeg?v=sy2nztieexq",
  description: "\n"
}];
export default function FeaturedWork() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="featuredwork" ref={ref} className="w-full bg-background transition-opacity duration-700 opacity-100 ![padding:0px_0px_96px_0px]">
      <div className="container mx-auto px-4 md:px-8">
        <div className="mb-16 max-w-2xl">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-4"><br /></h2>
          
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {projects.map((project, i) => <div key={project.id} data-index={i} className="group h-full">
              <Card className="text-card-foreground flex flex-col gap-6 h-full border border-border rounded-[2px] bg-card overflow-hidden transition-all duration-300 !p-0 hover:border-primary/50 hover:shadow-md">
                <CardContent className="p-0 relative">
                  <div className="relative w-full border-b border-border/50">
                    <AspectRatio ratio={4 / 3}>
                      <img src={project.image} alt={project.title} className="object-cover w-full h-full contrast-125 transition-all duration-500 group-hover:scale-105" />
                      {}
                      <div className="absolute inset-0 pointer-events-none shadow-[inset_0_0_40px_rgba(0,0,0,0.15)] group-hover:shadow-[inset_0_0_20px_rgba(0,0,0,0.05)] transition-shadow duration-500" />
                      
                      {}
                      <div className="absolute top-4 left-4">
                        
                      </div>
                    </AspectRatio>
                  </div>

                  <div className="flex flex-col gap-3 ![padding:15px_24px_0px_24px]">
                    <div className="flex justify-between items-start gap-4">
                      <h3 className="text-xl font-semibold text-foreground group-hover:text-primary transition-colors duration-300">
                        {project.title}
                      </h3>
                      <ArrowUpRight className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors duration-300 shrink-0" />
                    </div>
                    <p className="text-muted-foreground text-sm leading-relaxed">
                      {project.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}